import React, { useState } from 'react';
import useAuth from '../hooks/useAuth';
import '../styles/NewDiscussion.css';

const NewDiscussion = ({ postId, onDiscussionAdded, onCancel }) => {
  const [content, setContent] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const { createDiscussion } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!content.trim()) {
      setError('Discussion content cannot be empty');
      return;
    }

    try {
      setIsSubmitting(true);
      setError(null);
      
      const response = await createDiscussion({
        parentId: postId,
        content: content
      });
      
      if (response.ok) {
        onDiscussionAdded({ success: true });
        setContent('');
      } else {
        throw new Error('Failed to create discussion');
      }
    } catch (err) {
      setError(err.message || 'Failed to create discussion. Please try again.');
      console.error('Error creating discussion:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="new-discussion-modal">
      <div className="new-discussion-container">
        <h3 className="new-discussion-title">Start a Discussion</h3>
        
        {error && <div className="new-discussion-error">{error}</div>}
        
        <form onSubmit={handleSubmit} className="new-discussion-form">
          <textarea 
            className="new-discussion-textarea"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="What do you want to discuss about this post?"
            rows={4}
            required
          />
          
          <div className="new-discussion-actions">
            <button 
              type="button"
              className="cancel-button"
              onClick={onCancel}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            
            <button 
              type="submit"
              className="submit-button"
              disabled={isSubmitting || !content.trim()}
            >
              {isSubmitting ? 'Posting...' : 'Start'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewDiscussion;
